import { API_BASE_URL } from '../constants/suggestions';

export const uploadDocuments = async (files, token) => {
  if (!files || files.length === 0) {
    throw new Error('Please select at least one file.');
  }

  const formData = new FormData();
  Array.from(files).forEach((file) => formData.append('files', file));

  const response = await fetch(`${API_BASE_URL}/api/upload`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    
    // Handle 409 Conflict (duplicate file)
    if (response.status === 409) {
      let errorDetails = errorText || 'File already exists';
      try {
        const errorData = JSON.parse(errorText);
        if (errorData.detail && typeof errorData.detail === 'object' && errorData.detail.message) {
          errorDetails = errorData.detail.message;
          if (errorData.detail.existing_path) {
            errorDetails += `\n\nLocation: ${errorData.detail.existing_path}`;
          }
        }
      } catch (e) {
        // If parsing fails, use the plain text error
      }
      throw new Error(errorDetails);
    }
    
    throw new Error(errorText || `Upload failed with status ${response.status}`);
  }

  return response.json();
};
